<template>
  <v-app id="">
    <Overlay />
    <Snackbar />
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-layout row wrap align-center justify-center>
              <v-flex xs5 md5 align-center justify-center class="mb-12">
                <v-img
                  src="/img/logo.png"
                  align-center
                  width="250px"
                  justify-center
                ></v-img>
              </v-flex>
            </v-layout>
            <v-alert dense border="left" type="error" v-model="message">
              E-mail ou Senha inválidos!
            </v-alert>
            <form @submit.prevent="login">
              <v-card outlined>
                <v-toolbar flat>
                  <v-toolbar-title>
                    <span class="font-weight-bold" style="font-size: 16pt"
                      >Entrar</span
                    >
                  </v-toolbar-title>

                  <v-spacer></v-spacer>
                  <!-- <v-btn color="primary" @click="$router.push({name: 'register'})">Cadastre-se</v-btn> -->
                </v-toolbar>
                <v-form ref="form">
                  <v-card-text>
                    <v-text-field
                      dense
                      outlined
                      label="Login"
                      v-model="user.login"
                      placeholder="Login"
                      prepend-icon="person"
                      type="text"
                      autocomplete="new-login"
                      required
                      :rules="rules.login"
                      id="input-login"
                    >
                    </v-text-field>

                    <v-text-field
                      dense
                      outlined
                      label="Senha"
                      v-model="user.password"
                      prepend-icon="lock"
                      type="password"
                      autocomplete="new-password"
                      placeholder="******"
                      required
                      @keyup.enter="login"
                      :rules="rules.password"
                      id="input-password"
                    >
                    </v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="error"
                      @click="$router.push({ name: 'recoverPassword' })"
                      outlined
                      >Esqueci a senha
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="login" id="btn-entrar" outlined 
                      >ENTRAR</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Overlay from "@/components/shared/Overlay";
import Snackbar from "@/components/shared/Snackbar";
import axios from 'axios'
export default {
  props: {
    source: String,
  },
  components: {
    Overlay,
    Snackbar,
  },
  data() {
    return {
      drawer: null,
      user: {
        login: "",
        password: "",
      },
      message: false,
      rules: {
        login: [(v) => !!v || "Campo obrigatório."],
        password: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.$store.commit("setOverlay", true);
        axios
          .post(`${this.$urlApi}/v1/login`, this.user, {headers: {TenantId: this.$subdomain}})
          .then((res) => {
            if (res.data.status) {
              let redirectTo = sessionStorage.redirectTo;
              this.$store.commit("setUser", res.data.user);
              sessionStorage.setItem("user", JSON.stringify(res.data.user));
              sessionStorage.setItem("token", res.data.user.token);
              sessionStorage.setItem(
                "empresaId",
                parseInt(res.data.user.empresa_id)
              );
              sessionStorage.setItem(
                "empresa",
                JSON.stringify(res.data.user.empresa)
              );

              if (res.data.user.perfil.perfil == "Vendedor") {
                this.$router.push({ name: "vendaCadastro" });
                location.reload();
              }

              if (redirectTo == undefined) {
                location.reload();
              } else {
                window.location.replace(`${redirectTo}`);
                location.reload();
              }
            } else {
              this.message = true;
            }
            this.$store.commit("setOverlay", false);
          })
          .catch((e) => {
            this.$store.commit("setOverlay", false);
            this.message = true;
          });
      }
    },
  },
  created() {
    let user = this.$store.getters.getUser;
    if (user) {
      this.$router.push({ name: "home" });
    }
  },
};
</script>

<style scoped>
#inspire {
  background: linear-gradient(to right, #232526, #414345);
}
</style>
